module.exports = __webpack_public_path__ + "static/media/scene8_furba5.02742903.wav";